import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function ChangePasswordPage() {
    const { changePassword } = useAuth();
    const navigate = useNavigate();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSubmit = useCallback(
        async (event) => {
            event.preventDefault();
            setError(null);
            setSuccess(false);

            if (newPassword !== confirmPassword) {
                setError('New passwords do not match');
                return;
            }

            if (newPassword.length < 8) {
                setError('New password must be at least 8 characters');
                return;
            }

            setSubmitting(true);
            try {
                await changePassword(currentPassword, newPassword);
                setSuccess(true);
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
                setTimeout(() => navigate('/'), 1200);
            } catch (err) {
                setError(err?.message || 'Failed to update password');
            } finally {
                setSubmitting(false);
            }
        },
        [changePassword, confirmPassword, navigate, newPassword, currentPassword]
    );

    return (
        <div style={{ maxWidth: '420px', margin: '80px auto', padding: '2rem', border: '1px solid #e5e5e5', borderRadius: '12px' }}>
            <h1 style={{ marginBottom: '1.5rem', textAlign: 'center' }}>Change password</h1>
            <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '1rem' }}>
                <label style={{ display: 'grid', gap: '0.5rem' }}>
                    <span>Current password</span>
                    <input
                        type="password"
                        required
                        value={currentPassword}
                        onChange={(event) => setCurrentPassword(event.target.value)}
                        autoComplete="current-password"
                    />
                </label>

                <label style={{ display: 'grid', gap: '0.5rem' }}>
                    <span>New password</span>
                    <input
                        type="password"
                        required
                        value={newPassword}
                        onChange={(event) => setNewPassword(event.target.value)}
                        autoComplete="new-password"
                    />
                </label>

                <label style={{ display: 'grid', gap: '0.5rem' }}>
                    <span>Confirm new password</span>
                    <input
                        type="password"
                        required
                        value={confirmPassword}
                        onChange={(event) => setConfirmPassword(event.target.value)}
                        autoComplete="new-password"
                    />
                </label>

                {error ? (
                    <div style={{ color: '#b91c1c', background: '#fee2e2', padding: '0.75rem', borderRadius: '8px' }}>{error}</div>
                ) : null}

                {success ? (
                    <div style={{ color: '#166534', background: '#dcfce7', padding: '0.75rem', borderRadius: '8px' }}>
                        Password updated successfully
                    </div>
                ) : null}

                <button type="submit" className="primary-btn" disabled={submitting}>
                    {submitting ? 'Updating…' : 'Update password'}
                </button>
            </form>
        </div>
    );
}
